<template>

    <v-card>


      <v-card-text>
        
        <v-container>

          <v-textarea 
            v-model="question"
            auto-grow
            label="Ask a question!"
            rows="1"
            v-on:keydown.enter.prevent
            v-on:keyup.enter="submit"
          >
          </v-textarea>

          <div>
            <v-btn :disabled="preparing" v-on:click="submit" color="rgba(122,153,177,1)">
              <div id="btn-text">Ask</div>
            </v-btn>
          
            <div v-if="preparing" id="loader">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
              We are loading the demo...
            </div>

          </div>

        </v-container>

      </v-card-text>

    </v-card>

</template>

<script>

export default {
  name: 'Input',

  data: function() {
    return {
      question: ""
    }
  },

  props: {
    preparing: Boolean
  },

  methods: {

    submit: function() {

      this.$emit("asked", this.question)

    }

  }
  
}

</script>

<style scoped>
#header {
  overflow: hidden;
  height: 2vh;
}

#loader {
  display: inline-block;
  margin-left: 1em;
}

#btn-text {
  color: white;
}

</style>
